const SvgCheck = (props) => (
  <svg
    width="1.65rem"
    height="1.15rem"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m1 7.5 5 5L17.5 1" stroke="#A66E49" strokeWidth={2} />
  </svg>
);

export default SvgCheck;
